<template>
  <transition name="appfade">
    <div v-show="appIsLoaded" class="home-page--template page-template">
        <div class="container-fluid-full-width relative">
          <section class="container-fluid-full-width relative vh-100 relative center flex flex-column justify-center content-center items-center overflow-y-hidden">
            <!-- <video id="bgvid" autoplay="" loop="" muted="" playsinline="" style="background-color: #000;"> <source src="/assets/video/clip-combined.mov" type="video/mp4">Your browser does not support the video tag.</video> -->
            <div  class="db relative w-100 center z-3 mw6 content-wrap">
              <div class="db relative center mv3 mv4-ns home-mob-rep-badge-animation">
                <router-link class="bb pointer" to="/home/"></router-link>
              </div>
              <!-- <router-link class="db relative center home-mob-rep-badge" to="/home/"><img class="db img-responsive center" src="/uploadss/mobocratic-republic-badge-no-text-white.png" /></router-link> -->
              <div id="title-bar-1" class="db relative center title-bar"></div>
              <h1 style="" class="f2 mt1 mb1 lh-solid ttu tc is-bebas is-white">
                Mobocratic
                <span class="db mv1">Republic</span>
              </h1>
              <div id="title-bar-2" class="db relative center title-bar"></div>
              <div class="db relative center mt3" v-html="">
                <p class="f5 f3-ns mv1 tc ttu is-bebas is-white">
                  Curating experiences in Chicago and beyond
                </p>
                <p class="f3 tc mt2 mb0 nb3 ttu is-portago is-white">
                  Be the first to hear details
                </p>
                <div class="db relative center mv1 mw21rem">
                  <signup></signup>
                </div>
              </div>
            </div>
            <div id="cta-banner" class="db absolute bottom-0 left-0 right-0 h2 z-4 cta-banner">
              <a class="db relative center no-underline pointer home-cta-link" :href="page.next_event_banner.link" target="_blank">
                <div class="db relative center h2 bg-blue">
                  <div class="flex h-100 flex-row justify-around items-center content-center center ph1" style="max-width: 54rem;">
                    <p id="cta-banner-text" class="f5 tc ttu lh-title mv0 is-bebas is-white cta-banner-text">
                      Next Event: <span class="">{{ page.next_event_banner.text }}</span>
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </section>    
      </div>
      <div class="relative container-fluid">
        <section class="db relative z-3 center mw8">
          <!-- content -->
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import AppHeader from './app-header.vue';
import AppFooter from './app-footer.vue';
import Signup from './signup.vue';
import { bus } from '../assets/js/src/main';
import Marked from 'marked';
export default {
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
    'signup': Signup
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk}` : '';
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      appIsLoaded: true,
      //next_event_link: this.$next_event_link
      //index = '',
      //
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('home.md');
      return pageData[0];
    }
  },
  methods: {
    openVidModal(data) {
      console.log('1 ');
      bus.$emit('openVidModal', data);
      console.log('2 ');
    }
  },
  mounted() {
    this.$nextTick(() => {
      /****************************
        DOC READY
      ****************************/
      $(function() {

        var $element = $("#example");
        $element.velocity({ width: "300px" }, { duration: 500, delay: 1000 }, { easing: "ease-in-out" });

        var $titleBarOne = $("#title-bar-1");
        $titleBarOne.velocity({ width: "240px" }, { duration: 500, delay: 500 }, { easing: "ease-in-out" });

        var $titleBarTwo = $("#title-bar-2");
        $titleBarTwo.velocity({ width: "240px" }, { duration: 500, delay: 1000 }, { easing: "ease-in-out" });

        var $ctaBanner = $("#cta-banner");
        $ctaBanner.velocity({ width: "100%" }, { duration: 1000, delay: 1500 }, { easing: "ease-in-out" });

        var $ctaBannerText = $("#cta-banner-text");
        $ctaBannerText.velocity({ opacity: 1 }, { duration: 1000, delay: 1750 }, { easing: "ease-in-out" });

      })
    })
  }
}
</script>